import { Helmet } from 'react-helmet';

import useGoBack from '@/hooks/useGoBack';
import useScreenSize from '@/hooks/useScreenSize';
import LikeIcon from '@/shared-components/icons/components/new-icons/LikeIcon';
import RatingIcon from '@/shared-components/icons/components/new-icons/RatingIcon';
import ThoughtIcon from '@/shared-components/icons/components/new-icons/ThoughtIcon';
import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';
import {
  buildLocalizedAlternateUrls,
  resolveCurrentPathLocale,
  resolveLocalizedCanonicalUrl,
} from '@/utils/localePublicUrl';

import './styles/ArtworkNotFound.css';

export default function ArtworkNotFound() {
  const goBackHandler = useGoBack();
  const screenSize = useScreenSize();
  const resolvedLocale = resolveCurrentPathLocale();
  const resolvedCanonicalUrl = resolveLocalizedCanonicalUrl({ canonicalPath: "/", locale: resolvedLocale });
  const alternateUrls = buildLocalizedAlternateUrls({ canonicalPath: "/", locale: resolvedLocale });

  return (
    <>
      <Helmet>
        <html lang={resolvedLocale} />
        <title>Artwork Not Found | Suarte</title>
        <meta name="description" content="This artwork is not available on Suarte." />
        <meta name="robots" content="noindex,nofollow" />
        <meta name="googlebot" content="noindex,nofollow" />
        <link rel="canonical" href={resolvedCanonicalUrl} />
        {alternateUrls.map((alternate) => (
          <link key={alternate.hrefLang} rel="alternate" hrefLang={alternate.hrefLang} href={alternate.href} />
        ))}
      </Helmet>
      <div className="artwork-not-found__container">
        <div className="artwork-not-found__header --main">
          <BackArrowIcon className="artwork-not-found__back" onClick={goBackHandler}/>
          <div className="artwork-not-found__gallery-image"/>
          <div className="artwork-not-found__gallery-name"/>
        </div>

        <div className="artwork-not-found__image-container">
          <div className="artwork-not-found__image"/>
        </div>

        <div className="artwork-not-found__content">
          <div className="artwork-not-found__header">
            <BackArrowIcon className="artwork-not-found__back" onClick={goBackHandler}/>
            <div className="artwork-not-found__gallery-image"/>
            <div className="artwork-not-found__gallery-name"/>
          </div>

          <div className="artwork-not-found__label">
            <div className="artwork-not-found__artist">
              <div className="artwork-not-found__artist-image"/>
              <div className="artwork-not-found__artist-text-container">
                <div className="artwork-not-found__small-text" style={{ width: "150px" }}/>
                <div className="artwork-not-found__small-text" style={{ width: "100px" }}/>
              </div>
            </div>

            <span className="artwork-not-found__artwork-title font-size-medium">
              Artwork not found
            </span>

            <div className="artwork-not-found__small-text" style={{ width: "110px" }}/>
            <div className="artwork-not-found__small-text" style={{ width: "130px" }}/>
            <div className="artwork-not-found__small-text" style={{ width: "90px" }}/>

            <div className="artwork-not-found__social-icons">
              <RatingIcon className="artwork-not-found__social-icon"/>
              <ThoughtIcon className="artwork-not-found__social-icon"/>
              <LikeIcon className="artwork-not-found__social-icon"/>
            </div>
          </div>

          <div className="artwork-not-found__small-text" style={{ width: "100%", marginBottom: "8px" }}/>
          <div className="artwork-not-found__small-text" style={{ width: "100%", marginBottom: "8px" }}/>
          {screenSize.width > 900 && (
            <>
              <div className="artwork-not-found__small-text" style={{ width: "100%", marginBottom: "8px" }}/>
              <div className="artwork-not-found__small-text" style={{ width: "100%", marginBottom: "8px" }}/>
            </>
          )}

        </div>
      </div>
    </>
  );
}
